import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    let lenis = null;
    let rafId;

    if (!prefersReduced) {
      lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      window.__lenis = lenis;

      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    }

    // Intercept in-page anchor links so they scroll to the section top
    // (accounting for the fixed nav) instead of fighting Lenis / jumping wrong.
    const onClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const hash = link.getAttribute("href");
      if (!hash || hash === "#" || hash.length < 2) return;
      const target = document.querySelector(hash);
      if (!target) return;

      e.preventDefault();
      const navH = window.innerWidth >= 1024 ? 128 : 96;
      const y = Math.max(
        target.getBoundingClientRect().top + window.scrollY - navH - 12,
        0
      );

      if (lenis) {
        lenis.scrollTo(y, { duration: 1.0 });
      } else {
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      window.history.pushState(null, "", hash);
    };

    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      if (lenis) {
        cancelAnimationFrame(rafId);
        lenis.destroy();
        delete window.__lenis;
      }
    };
  }, []);
}
